import React from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import PalletStackingManagementColumnModel from './pallet-stacking-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'

const PalletStackingManagementPage = (): any => {
  return (
    <>
      <CommonTablePage
        urlInfoKey={urlKey.PalletStacking}
        title="Pallet Stacking Management"
        mappingUpdateData={(dataDetail: any) => {
          const ctnsPerLevel = parseInt(dataDetail.ctnsPerLevel, 10) || 0
          const level = parseInt(dataDetail.level, 10) || 0
          const addOnQty = parseInt(dataDetail.addOnQty, 10) || 0
          const calculatedQuantity = ctnsPerLevel * level + addOnQty
          return {
            ...dataDetail,
            ctnsPerLevel: ctnsPerLevel,
            level: level,
            addOnQty: addOnQty,
            quantity: calculatedQuantity > 0 ? calculatedQuantity : parseInt(dataDetail.quantity, 10) || 0
          }
        }}
        mappingRenderData={(data: any) => data.map((row: any) => ({...row, layoutImage2: row.layoutImage}))}
        column={PalletStackingManagementColumnModel.PalletStackingManagementColumn}
      />
    </>
  )
}

export default PalletStackingManagementPage
